/* Chaotic-style product page behaviour (cz-pp) */
let eventsModule = null;
try {
  eventsModule = await import('@shopify/events');
} catch (e) {
  eventsModule = null;
}

function formatMoney(cents, format) {
  const n = (cents / 100).toFixed(2);
  const [whole, dec] = n.split('.');
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return format
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
    .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec)
    .replace(/<[^>]+>/g, '');
}

function init(root) {
  if (root.dataset.czReady) return;
  root.dataset.czReady = '1';
  const data = JSON.parse(root.querySelector('[data-cz-product-json]').textContent);

  /* Gallery */
  const slides = root.querySelector('[data-cz-slides]');
  const thumbs = [...root.querySelectorAll('.cz-pp__thumb')];
  const slideEls = slides ? [...slides.children] : [];
  let index = 0;
  const go = (i) => {
    if (!slideEls.length) return;
    index = (i + slideEls.length) % slideEls.length;
    slides.style.transform = `translateX(${-100 * index}%)`;
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === index));
    const active = thumbs[index];
    if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  root.querySelector('[data-cz-prev]')?.addEventListener('click', () => go(index - 1));
  root.querySelector('[data-cz-next]')?.addEventListener('click', () => go(index + 1));
  let x0 = null;
  slides?.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  slides?.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    x0 = null;
  });
  const goToMedia = (mediaId) => {
    if (!mediaId) return;
    const k = slideEls.findIndex((s) => s.dataset.mediaId === String(mediaId));
    if (k >= 0) go(k);
  };

  /* Variants */
  const form = root.querySelector('[data-cz-form]');
  const idInput = root.querySelector('[data-cz-variant-id]');
  const optionSets = [...root.querySelectorAll('[data-cz-option]')];
  const atc = root.querySelector('[data-cz-atc]');
  const atcText = root.querySelector('[data-cz-atc-text]');
  const nowEl = root.querySelector('[data-cz-now]');
  const compareEl = root.querySelector('[data-cz-compare]');
  const saveEl = root.querySelector('[data-cz-save]');
  const selected = () => optionSets.map((fs) => fs.querySelector('input:checked')?.value);
  const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));

  const markAvailability = () => {
    const opts = selected();
    optionSets.forEach((fs, i) => {
      fs.querySelectorAll('.cz-pp__pill').forEach((pill) => {
        const val = pill.querySelector('input').value;
        const test = [...opts];
        test[i] = val;
        const v = findVariant(test);
        pill.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  };

  const applyVariant = () => {
    const opts = selected();
    optionSets.forEach((fs, i) => {
      const lbl = fs.querySelector('[data-cz-option-value]');
      if (lbl) lbl.textContent = opts[i] || '';
    });
    const v = findVariant(opts);
    markAvailability();
    if (!v) {
      atc.disabled = true;
      atcText.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    nowEl.textContent = formatMoney(v.price, data.moneyFormat);
    if (v.compare > v.price) {
      compareEl.textContent = formatMoney(v.compare, data.moneyFormat);
      compareEl.hidden = false;
      saveEl.textContent = `Save ${Math.round(((v.compare - v.price) * 100) / v.compare)}%`;
      saveEl.hidden = false;
    } else {
      compareEl.hidden = true;
      saveEl.hidden = true;
    }
    atc.disabled = !v.available;
    atcText.textContent = v.available ? 'Add to cart' : 'Sold out';
    goToMedia(v.media);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  };
  optionSets.forEach((fs) => fs.addEventListener('change', applyVariant));
  markAvailability();

  /* Quantity */
  const qty = root.querySelector('[data-cz-qty-input]');
  root.querySelectorAll('[data-cz-qty]').forEach((b) =>
    b.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.czQty, 10));
    })
  );

  /* Personalization */
  const nameInput = root.querySelector('[data-cz-name]');
  const numInput = root.querySelector('[data-cz-number]');
  const numToggle = root.querySelector('[data-cz-number-toggle]');
  numToggle?.addEventListener('change', () => {
    numInput.disabled = !numToggle.checked;
    numInput.required = numToggle.checked;
    if (!numToggle.checked) { numInput.value = ''; numInput.classList.remove('is-invalid'); }
  });
  numInput?.addEventListener('input', () => { numInput.value = numInput.value.replace(/\D/g, ''); });
  [nameInput, numInput].forEach((el) => el?.addEventListener('input', () => el.classList.remove('is-invalid')));
  /* GMC đợt 32: ô cá nhân hoá linh hoạt (block "field") */
  const czFields = [...root.querySelectorAll('[data-cz-field]')];
  /* GMC đợt 35: ô tích mở phần cá nhân hoá — chưa tích thì ô bị disabled (không gửi, không bắt buộc) */
  const persToggle = root.querySelector('[data-cz-pers-toggle]');
  const persWrap = root.querySelector('[data-cz-pers-fields]');
  const syncPersToggle = () => {
    if (!persToggle || !persWrap) return;
    const on = persToggle.checked;
    persWrap.hidden = !on;
    czFields.forEach((el) => { el.disabled = !on; if (!on) el.classList.remove('is-invalid'); });
  };
  persToggle?.addEventListener('change', syncPersToggle);
  syncPersToggle();
  czFields.forEach((el) => {
    el.addEventListener('input', () => {
      if (el.hasAttribute('data-cz-numeric')) el.value = el.value.replace(/\D/g, '');
      el.classList.remove('is-invalid');
    });
    el.addEventListener('change', () => el.classList.remove('is-invalid'));
  });

  const errorEl = root.querySelector('[data-cz-error]');
  const showError = (msg) => {
    errorEl.textContent = msg;
    errorEl.hidden = !msg;
  };

  const validate = () => {
    let ok = true;
    if (nameInput) {
      nameInput.value = nameInput.value.trim().toUpperCase();
      if (!nameInput.value) { nameInput.classList.add('is-invalid'); ok = false; }
    }
    if (numInput && numToggle?.checked && !/^\d+$/.test(numInput.value)) { numInput.classList.add('is-invalid'); ok = false; }
    for (const el of czFields) {
      if (el.disabled) continue;
      const isFile = el.type === 'file';
      if (!isFile) {
        el.value = el.value.trim();
        if (el.hasAttribute('data-cz-upper')) el.value = el.value.toUpperCase();
      }
      const file = isFile && el.files ? el.files[0] : null;
      if (file && file.size > 20 * 1024 * 1024) { el.classList.add('is-invalid'); showError('That file is too large (max 20 MB).'); el.focus(); return false; }
      const empty = isFile ? !file : !el.value;
      if (el.required && empty) { el.classList.add('is-invalid'); ok = false; }
    }
    if (!ok) {
      showError(czFields.length ? 'Please fill in the required personalization fields.' : 'Please enter the name and number you want printed.');
      (root.querySelector('.is-invalid') || nameInput)?.focus();
    }
    return ok;
  };

  const refreshCart = async () => {
    const cic = document.querySelector('cart-items-component');
    if (cic && cic.fetchCartData) {
      await customElements.whenDefined('cart-items-component');
      return cic.fetchCartData();
    }
    const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  };

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');
    if (atc.disabled || !validate()) return;
    atc.classList.add('is-loading');

    const fd = new FormData(form);
    for (const [k, v] of [...fd.entries()]) {
      if (!k.startsWith("properties[")) continue;
      if (v instanceof File ? !v.name : !String(v).trim()) fd.delete(k); // ô trống / chưa chọn file → không gửi
    }
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    const quantity = Number(fd.get('quantity')) || 1;
    const hasDrawer = !!document.querySelector('cart-drawer-component');

    let deferred = null;
    if (eventsModule?.CartLinesUpdateEvent && hasDrawer) {
      const { CartLinesUpdateEvent } = eventsModule;
      deferred = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(fd.get('id')), quantity }],
        promise: deferred.promise,
      }));
    }

    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const json = await res.json();
      if (json.status) {
        showError(json.description || json.message || 'Could not add to cart.');
        if (deferred) {
          const cart = await refreshCart();
          deferred.resolve({ cart: eventsModule.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'cz-product', sourceId: root.dataset.sectionId, itemCount: quantity, productId: root.dataset.productId } });
        }
        return;
      }
      if (!deferred) { window.location.href = (window.Shopify?.routes?.root || '/') + 'cart'; return; }
      const cart = await refreshCart();
      deferred.resolve({
        cart: eventsModule.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'cz-product', sourceId: root.dataset.sectionId, itemCount: quantity, productId: root.dataset.productId, sections: json.sections, didError: false },
      });
      atcText.textContent = 'Added!';
      setTimeout(() => { atcText.textContent = 'Add to cart'; }, 1800);
    } catch (err) {
      deferred?.reject(err);
      showError('Network error, please try again.');
    } finally {
      atc.classList.remove('is-loading');
    }
  });

  /* Size chart modal */
  root.querySelectorAll('[data-cz-open]').forEach((b) =>
    b.addEventListener('click', () => { const m = root.querySelector(`[data-cz-modal="${b.dataset.czOpen}"]`); if (m) m.hidden = false; })
  );
  root.querySelectorAll('[data-cz-close]').forEach((b) => b.addEventListener('click', () => { b.closest('[data-cz-modal]').hidden = true; }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') root.querySelectorAll('[data-cz-modal]').forEach((m) => { m.hidden = true; }); });

  /* Share */
  const share = root.querySelector('[data-cz-share]');
  share?.addEventListener('click', async () => {
    const url = share.dataset.url, title = share.dataset.title;
    if (navigator.share) { try { await navigator.share({ title, url }); } catch (e) {} return; }
    try { await navigator.clipboard.writeText(url); share.querySelector('[data-cz-share-text]').textContent = 'Link copied'; setTimeout(() => { share.querySelector('[data-cz-share-text]').textContent = 'Share'; }, 2000); } catch (e) {}
  });
}

document.querySelectorAll('[data-cz-product]').forEach(init);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-cz-product]').forEach(init));
